<template>
  <!-- 考试班级下的参考学员列表 -->
  <div class="exam_paper_top">
        <el-button
          type="primary"
          class="dialog_title_btn"
          @click="updateEnglishClass"
          icon="el-icon-refresh-right"
          >更新英语班级</el-button
        >
          </el-button>
          <el-button
          type="primary"
          class="dialog_title_btn"
          @click="modifyClass"
          icon="el-icon-edit-outline"
          >批量修改班级信息</el-button
        >
          </el-button>
          <class-list v-bind:isRelation="true"
          :ExamAndHomeworkCreate="true" @changedCallback1="changeGrade"
          :classDialog="true" @closeDialogClass="closeDialogClass" :showStudentDetail="showStudentDetail" v-if="studentDialog"></class-list>
    <StudentsTableHeader
      id="StudentDetail"
      :empty-text="emptyText"
      :table-height="tableMaxHeight + 50"
      :distributionIsShow="false"
      :isShowAllBtn="false"
      componentTableId="StudentDetail"
      excelName="参考学员"
      :header-data="headerData"
      :table-data="tableData"
      :pagination="pagination"
      @update-list="updataList"
      :table-loading="tableLoading"
      :element-loading-text="loadingText"
      @search-data="tableSearch"
      ref="tableRef"
      style="border-right: 1px solid #ebeef5;"
      @handleSelectionChange1="handleSelectionChange"
    >
      <template v-slot:isAICheckcustom="scope">
        <el-tag v-if="scope.scope.isAICheck" type="success">是</el-tag>
        <el-tag v-else type="info">否</el-tag>
      </template>
      <template v-slot:allOrdercustom="scope">
        <span v-if="scope.scope.allOrder!=0">第{{ scope.scope.allOrder }}名</span>
        <span v-else class="gray">暂无</span>
      </template>
      <template v-slot:orderscustom="scope">
        <span v-if="scope.scope.orders!=0">第{{ scope.scope.orders }}名</span>
        <span v-else class="gray">暂无</span>
      </template>
      <template v-slot:beginTimecustom="scope">
        <span v-if="scope.scope.beginTime&&scope.scope.endTime">{{ formatTimeRange(scope.scope.beginTime, scope.scope.endTime )}}</span>
        <span v-else class="gray">暂无</span>
      </template>
      <template v-slot:aiCheckTimecustom="scope">
        <span
            v-if="
              scope.scope.aiCheckTime == '' ||
              scope.scope.aiCheckTime == null ||
              scope.scope.aiCheckTime == '0001-01-01T00:00:00' ||
              scope.scope.aiCheckTime == '0001-01-01 00:00:00' ||
              scope.scope.aiCheckTime == '1900-01-01 00:00:00'
            "
            class="gray"
            >暂无</span
          >
      </template>
      <template v-slot:subjectCountcustom="scope">
        <span
            v-if="
              scope.scope.subjectCount && !scope.scope.isImport"
            >{{ scope.scope.subjectCount }}道</span
          >
          <span v-else-if="scope.scope.isImport"
          class="gray"
          >无（线下考试）</span>
      </template>
      <template v-slot:noCountcustom="scope">
        <span
            v-if="
              scope.scope.noCount && !scope.scope.isImport"
            >{{ scope.scope.noCount }}道</span
          >
          <span v-else-if="scope.scope.isImport"
          class="gray"
          >无（线下考试）</span>
          <span v-else class="gray">0道</span>
      </template>
      <template v-slot:noAnswerCountcustom="scope">
        <span
            v-if="
              scope.scope.noAnswerCount && !scope.scope.isImport"
            >{{ scope.scope.noAnswerCount }}道</span
          >
          <span v-else-if="scope.scope.isImport"
          class="gray"
          >无（线下考试）</span>
          <span v-else class="gray">0道</span>
      </template>
      <template v-slot:examinationStateNamecustom="scope">
        <el-tag
          :type="
            scope.scope.state == 1
              ? 'info'
              : scope.scope.state == 2
              ? ''
              : scope.scope.state == 3 || scope.scope.state == 4
              ? 'warning'
              : scope.scope.state == 5
              ? ''
              : scope.scope.state == 6
              ? 'success'
              : scope.scope.state == 7
              ? 'danger'
              : success
          "
          >{{ scope.scope.examinationStateName }}</el-tag
        >
      </template>
    </StudentsTableHeader>
    <!-- 底部工具 -->
    <pagination-tool
      :pagination="pagination"
      :is-loading="tableLoading"
      @change-pagination="changePagination"
    ></pagination-tool>
  </div>
</template>
<script>
import StudentsTableHeader from "components/StudentList";
import PaginationTool from "components/PaginationTool";
import { GetExamStudentListByExamId,UpdateExaminationNoGradeStudent,UpdateExaminationStudentGradeInfo } from "network/exam";
import { timeFormat, timeFormatNew, isNull } from "common/utils";
import classList from "components/ClassListGroup";

export default {
  components: {
    StudentsTableHeader,
    PaginationTool,
    classList
  },
  props: {
    examinationId: {},
    tableMaxHeight:{}
  },
  watch: {
    examinationId: {
      handler(newVal) {
        this.requestData.examinationId = newVal;
        this.getExamStudentListByExamId(newVal);
        this.headerData.map((item) => {
            if (item.prop == "examinationStateName") {
                item.selectOptions = this.$constGlobal.examStates;
            }
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      //加载中
      tableLoading: false,
      loadingText: "loading...", //加载状态提示文本
      headerData: [
      {
          label: "勾选框",
          type: "selection",
          align: "center",
          width: "55",
          fixed: "left",
        },
        {
          label: "学员名称",
          prop: "studentName",
          width: "130",
          align: "left",
          fixed: "left",
          inputSearch: true,
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "班级名称",
          prop: "gradeName",
          width: "160",
          align: "center",
          inputSearch: true,
          gradeName: null,
          noSetText: "无",
          noTooltip: true,
        },
        {
          label: "考试状态",
          prop: "examinationStateName",
          width: "140",
          align: "center",
          noTooltip: false,
          selectSearch: true,
          selectOptions: [],
          noTooltip: true,
          noSetText: "无",
          custom:true,
        },
        {
          label: "得分",
          prop: "studentScore",
          width: "100",
          align: "center",
          noSetText: "0",
          noTooltip: true,
          unit: true,
          unitText: "分",
          isNumber2: true,
        },
        {
          label: "得分排名",
          prop: "orders",
          width: "90",
          align: "center",
          noSetText: "无",
          noTooltip: true,
          custom: true,
        },
        {
          label: "综合排名",
          prop: "allOrder",
          align: "center",
          width: "90",
          noTooltip: true,
          noSetText: "无",
          custom: true,
        },
        {
          label: "答题时间",
          prop: "beginTime",
          align: "center",
          width: "320",
          noTooltip: true,
          noSetText: "无",
          custom: true,
        },
        {
          label: "所属招生老师",
          prop: "businessName",
          align: "center",
          width: "120",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "所属教务老师",
          prop: "handoverName",
          width: "120",
          align: "center",
          noTooltip: true,
          noSetText: "无",
        },
        {
          label: "题目数目",
          prop: "subjectCount",
          align: "center",
          width: "120",
          custom:true,
        },
        {
          label: "错题数据",
          prop: "noCount",
          align: "center",
          width: "120",
          custom:true,
        },
        {
          label: "未答题数目",
          prop: "noAnswerCount",
          align: "center",
          width: "120",
          custom:true,
        },
        {
          label: "是否AI检测",
          prop: "isAICheck",
          align: "center",
          width: "120",
          custom: true,
        },
        {
          label: "AI检测时间",
          prop: "aiCheckTime",
          align: "center",
          noTooltip: true,
          noSetText: "无",
          custom: true,
        },
      ],
      //分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      tableData: [],
      requestData: {
        pageIndex: 1,
        pageSize: 20,
        studentName: null,
        examinationId: null,
        gradeName: null,
        studentScoreStart: null,
        studentScoreEnd: null,
        state: null,
      },
      multipleSelection:[],
      studentDialog:false,
      showStudentDetail:true
    };
  },
  methods: {
    formatTimeRange(time1,time2) {
      let beginTime = timeFormatNew(time1,"yyyy-MM-dd");
      let endTime = timeFormatNew(time2,"yyyy-MM-dd");
      if(beginTime == endTime) {
        return beginTime + ' ' +  timeFormatNew(time1,"hh:mm:ss") + "至" + timeFormatNew(time2,"hh:mm:ss");
      }else{
        return beginTime + ' ' + timeFormatNew(time1,"hh:mm:ss") + "至" + time2;
      }
    },
    async getExamStudentListByExamId() {
      this.emptyText = "加载中";
      if (this.tableLoading) {
        return false;
      }
      this.tableLoading = true;
      this.loadingText = "loading...";
      const res = await GetExamStudentListByExamId(this.requestData);
      this.$nextTick(() => {
        this.tableLoading = false;
      });
      if (res.code == 1) {
        this.tableData = res.data;
        this.emptyText = this.tableData ? "" : "暂无数据";
        this.pagination.total = res.totalCount;
      } else {
        this.emptyText = "暂无数据";
        this.pagination.total = res.totalCount;
        this.tableData = res.data || [];
        this.$alert(res.msg);
      }
    },
    // 搜索返回值
    tableSearch(val) {
      if (!isNull(val.prop) && val.prop == "studentName") {
        this.requestData.studentName = val.value;
      }
      if (!isNull(val.prop) && val.prop == "studentScore") {
        this.requestData.studentScoreStart = val.value.select1
          ? val.value.select1
          : null;
        this.requestData.studentScoreEnd =  val.value.select2
          ? val.value.select2
          : null;
      }
      if (!isNull(val.prop) && val.prop == "gradeName") {
        this.requestData.gradeName = val.value;
      }
      if (!isNull(val.prop) && val.prop == "examinationStateName") {
        this.requestData.state = val.value == -1 ? null : val.value;
      }
      this.requestData.pageIndex = 1;
      this.pagination.currentPage = 1;
      this.getExamStudentListByExamId();
    },
    // 分页
    changePagination() {
      this.requestData.pageIndex = this.pagination.currentPage;
      this.requestData.pageSize = this.pagination.pageSize;
      this.updataList();
    },
     // 更新列表
     updataList() {
      this.getExamStudentListByExamId();
    },
    async updateEnglishClass(){
        try {
          await this.$confirm("系统将根据配置中心设置的关键字（如：上岸集训、全程先锋、金牌），自动匹配英语班级，为尚未显示班级的学员执行批量更新操作，确定要执行批量更新吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            beforeClose: async (action, ctx, close) => {
              if (action === "confirm") {
                ctx.confirmButtonLoading = true;
                ctx.confirmButtonText = "确认中";
                close();
                const result = await UpdateExaminationNoGradeStudent({examinationId:this.examinationId});
                if (result && result.code === 1) {
                  this.$alert(result.message, "提示", {
                    confirmButtonText: "确定",
                  });
                  this.updataList();
                } else {
                  this.$alert(result.message, "提示", {
                    confirmButtonText: "确定",
                  });
                }
                ctx.confirmButtonLoading = false;
                ctx.confirmButtonText = "确定";
              } else {
                close();
                ctx.confirmButtonLoading = false;
                ctx.confirmButtonText = "确定";
              }
            },
          });
        } catch (error) {
        }
    },
    // 表行勾选
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },
    modifyClass(){
      if (!this.multipleSelection[0]) {
        this.$message.error("请至少选择一条数据");
        return false;
      }
      this.studentDialog=true
      this.showStudentDetail=true
    },
    //选择班级
    async changeGrade(row) {
      if (row && JSON.stringify(row) != "{}") {
        try {
          await this.$confirm(`确认批量修改${this.multipleSelection.length}个学员的所属班级吗？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            beforeClose: async (action, ctx, close) => {
              if (action === "confirm") {
                ctx.confirmButtonLoading = true;
                ctx.confirmButtonText = "确认中";
                close();
                const res=await UpdateExaminationStudentGradeInfo({
                  gradeId:row.gradeId,
                  gradeName:row.gradeName,
                  examinationStudentIds:this.multipleSelection.map(item=>item.id)
                })
                if (res && res.code === 1) {
                  this.$alert(res.message, "提示", {
                    confirmButtonText: "确定",
                  });
                  this.updataList();
                  this.closeDialogClass()
                } else {
                  this.$alert(res.message, "提示", {
                    confirmButtonText: "确定",
                  });
                }
                ctx.confirmButtonLoading = false;
                ctx.confirmButtonText = "确定";
              } else {
                close();
                ctx.confirmButtonLoading = false;
                ctx.confirmButtonText = "确定";
              }
            },
          });
        } catch (error) {
        }
      }
    },
    closeDialogClass(){
      this.$refs.tableRef.clearHandle();
      this.multipleSelection=[]
      this.studentDialog=false
      this.showStudentDetail=false
    }
  },
};
</script>
<style lang="scss" scoped>  
  .exam_paper_top {
  position: fixed;
  top: 44px;
  padding-top: 15px;
  background-color: #fff;
  width: 99%;
  left: 10px;
}
</style>